[
  {
    "nutrient": "エネルギー",
    "reference": "（参考）推定エネルギー必要量",
    "ageGroups": {
      "18-29": {
        "male": "2600kcal",
        "female": "1950kcal"
      },
      "30-49": {
        "male": "2750kcal",
        "female": "2050kcal"
      },
      "50-64": {
        "male": "2650kcal",
        "female": "1950kcal"
      }
    }
  },
  {
    "nutrient": "タンパク質",
    "reference": "推奨量",
    "ageGroups": {
      "18-29": {
        "male": "65g",
        "female": "50g"
      },
      "30-49": {
        "male": "65g",
        "female": "50g"
      },
      "50-64": {
        "male": "65g",
        "female": "50g"
      }
    }
  },
  {
    "nutrient": "脂質",
    "reference": "目標量",
    "ageGroups": {
      "18-29": {
        "male": "20～30%",
        "female": "20～30%"
      },
      "30-49": {
        "male": "20～30%",
        "female": "20～30%"
      },
      "50-64": {
        "male": "20～30%",
        "female": "20～30%"
      }
    }
  },
  {
    "nutrient": "飽和脂肪酸",
    "reference": "目標量",
    "ageGroups": {
      "18-29": {
        "male": "7%以下",
        "female": "7%以下"
      },
      "30-49": {
        "male": "7%以下",
        "female": "7%以下"
      },
      "50-64": {
        "male": "7%以下",
        "female": "7%以下"
      }
    }
  },
  {
    "nutrient": "n-6系脂肪酸",
    "reference": "目安量",
    "ageGroups": {
      "18-29": {
        "male": "12g",
        "female": "9g"
      },
      "30-49": {
        "male": "11g",
        "female": "9g"
      },
      "50-64": {
        "male": "11g",
        "female": "9g"
      }
    }
  },
  {
    "nutrient": "n-3系脂肪酸",
    "reference": "目安量",
    "ageGroups": {
      "18-29": {
        "male": "2.2g",
        "female": "1.7g"
      },
      "30-49": {
        "male": "2.2g",
        "female": "1.7g"
      },
      "50-64": {
        "male": "2.3g",
        "female": "1.9g"
      }
    }
  },
  {
    "nutrient": "炭水化物",
    "reference": "目標量",
    "ageGroups": {
      "18-29": {
        "male": "50～65%",
        "female": "50～65%"
      },
      "30-49": {
        "male": "50～65%",
        "female": "50～65%"
      },
      "50-64": {
        "male": "50～65%",
        "female": "50～65%"
      }
    }
  },
  {
    "nutrient": "食物繊維",
    "reference": "目標量",
    "ageGroups": {
      "18-29": {
        "male": "20g以上",
        "female": "18g以上"
      },
      "30-49": {
        "male": "22g以上",
        "female": "18g以上"
      },
      "50-64": {
        "male": "22g以上",
        "female": "18g以上"
      }
    }
  },
  {
    "nutrient": "ビタミンA",
    "reference": "推奨量",
    "ageGroups": {
      "18-29": {
        "male": "850µg",
        "female": "650µg"
      },
      "30-49": {
        "male": "900µg",
        "female": "700µg"
      },
      "50-64": {
        "male": "900µg",
        "female": "700µg"
      }
    }
  },
  {
    "nutrient": "ビタミンD",
    "reference": "目安量",
    "ageGroups": {
      "18-29": {
        "male": "9.0µg",
        "female": "9.0µg"
      },
      "30-49": {
        "male": "9.0µg",
        "female": "9.0µg"
      },
      "50-64": {
        "male": "9.0µg",
        "female": "9.0µg"
      }
    }
  },
  {
    "nutrient": "ビタミンE",
    "reference": "目安量",
    "ageGroups": {
      "18-29": {
        "male": "6.5mg",
        "female": "5.0mg"
      },
      "30-49": {
        "male": "6.5mg",
        "female": "6.0mg"
      },
      "50-64": {
        "male": "6.5mg",
        "female": "6.0mg"
      }
    }
  },
  {
    "nutrient": "ビタミンK",
    "reference": "目安量",
    "ageGroups": {
      "18-29": {
        "male": "150µg",
        "female": "150µg"
      },
      "30-49": {
        "male": "150µg",
        "female": "150µg"
      },
      "50-64": {
        "male": "150µg",
        "female": "150µg"
      }
    }
  },
  {
    "nutrient": "ビタミンB1",
    "reference": "推奨量",
    "ageGroups": {
      "18-29": {
        "male": "1.1mg",
        "female": "0.8mg"
      },
      "30-49": {
        "male": "1.2mg",
        "female": "0.9mg"
      },
      "50-64": {
        "male": "1.1mg",
        "female": "0.8mg"
      }
    }
  },
  {
    "nutrient": "ビタミンB2",
    "reference": "推奨量",
    "ageGroups": {
      "18-29": {
        "male": "1.6mg",
        "female": "1.2mg"
      },
      "30-49": {
        "male": "1.7mg",
        "female": "1.2mg"
      },
      "50-64": {
        "male": "1.6mg",
        "female": "1.2mg"
      }
    }
  },
  {
    "nutrient": "ビタミンB6",
    "reference": "推奨量",
    "ageGroups": {
      "18-29": {
        "male": "1.5mg",
        "female": "1.2mg"
      },
      "30-49": {
        "male": "1.5mg",
        "female": "1.2mg"
      },
      "50-64": {
        "male": "1.5mg",
        "female": "1.2mg"
      }
    }
  },
  {
    "nutrient": "ビタミンB12",
    "reference": "推奨量",
    "ageGroups": {
      "18-29": {
        "male": "4.0µg",
        "female": "4.0µg"
      },
      "30-49": {
        "male": "4.0µg",
        "female": "4.0µg"
      },
      "50-64": {
        "male": "4.0µg",
        "female": "4.0µg"
      }
    }
  },
  {
    "nutrient": "ナイアシン",
    "reference": "推奨量",
    "ageGroups": {
      "18-29": {
        "male": "15mg",
        "female": "11mg"
      },
      "30-49": {
        "male": "16mg",
        "female": "12mg"
      },
      "50-64": {
        "male": "15mg",
        "female": "11mg"
      }
    }
  },
  {
    "nutrient": "葉酸",
    "reference": "推奨量",
    "ageGroups": {
      "18-29": {
        "male": "240µg",
        "female": "240µg"
      },
      "30-49": {
        "male": "240µg",
        "female": "240µg"
      },
      "50-64": {
        "male": "240µg",
        "female": "240µg"
      }
    }
  },
  {
    "nutrient": "パントテン酸",
    "reference": "目安量",
    "ageGroups": {
      "18-29": {
        "male": "6mg",
        "female": "5mg"
      },
      "30-49": {
        "male": "6mg",
        "female": "5mg"
      },
      "50-64": {
        "male": "6mg",
        "female": "5mg"
      }
    }
  },
  {
    "nutrient": "ビオチン",
    "reference": "目安量",
    "ageGroups": {
      "18-29": {
        "male": "50µg",
        "female": "50µg"
      },
      "30-49": {
        "male": "50µg",
        "female": "50µg"
      },
      "50-64": {
        "male": "50µg",
        "female": "50µg"
      }
    }
  },
  {
    "nutrient": "ビタミンC",
    "reference": "推奨量",
    "ageGroups": {
      "18-29": {
        "male": "100mg",
        "female": "100mg"
      },
      "30-49": {
        "male": "100mg",
        "female": "100mg"
      },
      "50-64": {
        "male": "100mg",
        "female": "100mg"
      }
    }
  },
  {
    "nutrient": "ナトリウム（食塩相当量）",
    "reference": "目標量",
    "ageGroups": {
      "18-29": {
        "male": "7.5g未満",
        "female": "6.5g未満"
      },
      "30-49": {
        "male": "7.5g未満",
        "female": "6.5g未満"
      },
      "50-64": {
        "male": "7.5g未満",
        "female": "6.5g未満"
      }
    }
  },
  {
    "nutrient": "カリウム",
    "reference": "目安量",
    "ageGroups": {
      "18-29": {
        "male": "2500mg",
        "female": "2000mg"
      },
      "30-49": {
        "male": "2500mg",
        "female": "2000mg"
      },
      "50-64": {
        "male": "2500mg",
        "female": "2000mg"
      }
    }
  },
  {
    "nutrient": "カルシウム",
    "reference": "推奨量",
    "ageGroups": {
      "18-29": {
        "male": "800mg",
        "female": "650mg"
      },
      "30-49": {
        "male": "750mg",
        "female": "650mg"
      },
      "50-64": {
        "male": "750mg",
        "female": "650mg"
      }
    }
  },
  {
    "nutrient": "マグネシウム",
    "reference": "推奨量",
    "ageGroups": {
      "18-29": {
        "male": "340mg",
        "female": "280mg"
      },
      "30-49": {
        "male": "380mg",
        "female": "290mg"
      },
      "50-64": {
        "male": "370mg",
        "female": "290mg"
      }
    }
  },
  {
    "nutrient": "リン",
    "reference": "目安量",
    "ageGroups": {
      "18-29": {
        "male": "1000mg",
        "female": "800mg"
      },
      "30-49": {
        "male": "1000mg",
        "female": "800mg"
      },
      "50-64": {
        "male": "1000mg",
        "female": "800mg"
      }
    }
  },
  {
    "nutrient": "鉄",
    "reference": "推奨量",
    "ageGroups": {
      "18-29": {
        "male": "7.0mg",
        "female": "月経なし6.0mg"
      },
      "30-49": {
        "male": "7.5mg",
        "female": "月経なし6.0mg"
      },
      "50-64": {
        "male": "7.0mg",
        "female": "月経なし6.0mg"
      }
    }
  },
  {
    "nutrient": "鉄",
    "reference": "推奨量",
    "ageGroups": {
      "18-29": {
        "male": "7.0mg",
        "female": "月経あり10.0mg"
      },
      "30-49": {
        "male": "7.5mg",
        "female": "月経あり10.5mg"
      },
      "50-64": {
        "male": "7.0mg",
        "female": "月経あり10.5mg"
      }
    }
  },
  {
    "nutrient": "亜鉛",
    "reference": "推奨量",
    "ageGroups": {
      "18-29": {
        "male": "9.0mg",
        "female": "7.5mg"
      },
      "30-49": {
        "male": "9.5mg",
        "female": "8.0mg"
      },
      "50-64": {
        "male": "9.5mg",
        "female": "8.0mg"
      }
    }
  },
  {
    "nutrient": "銅",
    "reference": "推奨量",
    "ageGroups": {
      "18-29": {
        "male": "0.8mg",
        "female": "0.7mg"
      },
      "30-49": {
        "male": "0.9mg",
        "female": "0.7mg"
      },
      "50-64": {
        "male": "0.9mg",
        "female": "0.7mg"
      }
    }
  },
  {
    "nutrient": "マンガン",
    "reference": "目安量",
    "ageGroups": {
      "18-29": {
        "male": "3.5mg",
        "female": "3.0mg"
      },
      "30-49": {
        "male": "3.5mg",
        "female": "3.0mg"
      },
      "50-64": {
        "male": "3.5mg",
        "female": "3.0mg"
      }
    }
  },
  {
    "nutrient": "ヨウ素",
    "reference": "推奨量",
    "ageGroups": {
      "18-29": {
        "male": "140µg",
        "female": "140µg"
      },
      "30-49": {
        "male": "140µg",
        "female": "140µg"
      },
      "50-64": {
        "male": "140µg",
        "female": "140µg"
      }
    }
  },
  {
    "nutrient": "セレン",
    "reference": "推奨量",
    "ageGroups": {
      "18-29": {
        "male": "30µg",
        "female": "25µg"
      },
      "30-49": {
        "male": "35µg",
        "female": "25µg"
      },
      "50-64": {
        "male": "30µg",
        "female": "25µg"
      }
    }
  },
  {
    "nutrient": "クロム",
    "reference": "目安量",
    "ageGroups": {
      "18-29": {
        "male": "10µg",
        "female": "10µg"
      },
      "30-49": {
        "male": "10µg",
        "female": "10µg"
      },
      "50-64": {
        "male": "10µg",
        "female": "10µg"
      }
    }
  },
  {
    "nutrient": "モリブデン",
    "reference": "推奨量",
    "ageGroups": {
      "18-29": {
        "male": "30µg",
        "female": "25µg"
      },
      "30-49": {
        "male": "30µg",
        "female": "25µg"
      },
      "50-64": {
        "male": "30µg",
        "female": "25µg"
      }
    }
  }
]